var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.9999C7.54131 3.9999 6.14236 4.57936 5.11091 5.61081C4.07946 6.64226 3.5 8.04121 3.5 9.4999C3.5 10.9586 4.07946 12.3575 5.11091 13.389C6.14236 14.4204 7.54131 14.9999 9 14.9999C10.4587 14.9999 11.8576 14.4204 12.8891 13.389C13.9205 12.3575 14.5 10.9586 14.5 9.4999C14.5 8.04121 13.9205 6.64226 12.8891 5.61081C11.8576 4.57936 10.4587 3.9999 9 3.9999ZM2 9.4999C2.00009 8.38057 2.26861 7.27758 2.78303 6.28346C3.29745 5.28934 4.04276 4.43308 4.95645 3.7865C5.87015 3.13991 6.92557 2.72187 8.0342 2.56744C9.14282 2.413 10.2723 2.52667 11.3279 2.89892C12.3836 3.27117 13.3345 3.89113 14.101 4.70681C14.8676 5.52249 15.4273 6.5101 15.7333 7.58679C16.0393 8.66348 16.0827 9.79785 15.8597 10.8948C15.6368 11.9917 15.154 13.0191 14.452 13.8909L17.78 17.2199C17.8537 17.2886 17.9128 17.3714 17.9538 17.4634C17.9948 17.5554 18.0168 17.6547 18.0186 17.7554C18.0204 17.8561 18.0018 17.9561 17.9641 18.0495C17.9264 18.1429 17.8703 18.2277 17.799 18.2989C17.7278 18.3702 17.643 18.4263 17.5496 18.464C17.4562 18.5017 17.3562 18.5203 17.2555 18.5185C17.1548 18.5167 17.0555 18.4947 16.9635 18.4537C16.8715 18.4127 16.7887 18.3536 16.72 18.2799L13.391 14.9519C12.3625 15.7803 11.1207 16.3008 9.80901 16.4535C8.49727 16.6061 7.16912 16.3845 5.97795 15.8144C4.78677 15.2443 3.78117 14.3489 3.07727 13.2315C2.37338 12.1142 1.99991 10.8205 2 9.4999Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchProject);
export default __webpack_public_path__ + "static/media/SearchProject.db4ce67ed69cb2e4cba862e3351dcca7.svg";
export { ForwardRef as ReactComponent };